
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[platform]/results",
      function () {
        return require("private-next-pages/[platform]/results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[platform]/results"])
      });
    }
  